/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component } from 'react';
import store from 'features/store';
import { Form, Button, Modal, Spinner, Table, ProgressBar } from 'react-bootstrap';
import { MyAccountMenuList, removeSideBar, ToggleSideBar } from '../MyAccountMenuList';
import Validators from 'shared/validators';
import { DokaImageEditor } from 'react-doka';
import { blobToFile } from 'doka';
import { getEditorDefaults, circleCropMask } from 'shared/doka';
import { connect } from 'react-redux';
import moment from 'moment';
import { MyAccountService } from 'shared/services';

import './TaxExemptions.scss';
import { isAuthorized, logout } from 'shared/settings/auth';
import { getBuyersUrl, getBuyerHeaders, } from 'shared/http';
import {
    fileUpload,
    fileUploadFragment
} from 'shared/settings/apiconfig';
import axios from 'axios';
import heic2any from 'heic2any';
import FileType from "file-type/browser";
import imageCompression from 'browser-image-compression';

/**


@Author Karthik

@param

@return html code for tax exemptions

**/

const CERTIFICATE_TYPES = 'image/jpeg, image/heic, image/jpg, image/png, image/heif, application/pdf';

class TaxExemptions extends Component {
    constructor(props) {
        super(props);
        this.state = {

            CurrentTime : new Date().toLocaleString(),

            // Temp file
            certificateFile: {
                modal: false,
                fileSrc: null,
                tempFile: null,
                viewFileDetails: null,
                date: null
            },

            // Certificate file
            finalCertificateFile: [],

            // form
            taxExemptionsForm: {
                certificate: { value: '', error: '', validators: [Validators.required()] }
            },
            taxExemptionsValid: false,
            pageLoading: true,
            imageLoading:false,
            viewFileDetailsModal: { open: false, index: 0 },
            activeFileIndex: { index: -1, fileid: -1 },
            loading: false,
            deleteInprogress: -1,
            activeNavBar: 'files',
            exemptioList: [],
            viewExemptionDetailsModal: { open: false, exemption: null },
            fileError: "",
            percentage: 0,
            isCompressing: false
        }
        this.customEditorDefaults = {
            imageCropAspectRatio: 1,
            cropEnableSelectPreset: false,
            imageCropMinSize: { width: 130, height: 130 },
            willRenderCanvas: (shapes, state) => circleCropMask(shapes, state)
        };
        this.certificateFile = null;
    }
    componentDidMount() {
        store.dispatch({ type: 'SIDEBAR_MENU_LIST', payload: { menuList: MyAccountMenuList(), withSpan: false } });
        this.getTaxFileList();
        this.getExemptionList();
        this.windowResizeHandle();
        window.addEventListener('resize', this.windowResizeHandle);
    }

    componentDidUpdate() {
        window.addEventListener('resize', this.windowResizeHandle);
    }

    getTaxFileList = () => {
        MyAccountService.getTaxFileList().then(
            response => {
                const data = response.data.data;
                this.setState({
                    finalCertificateFile: response.data.data,
                    deleteInprogress: -1
                }, () => {
                    if (data.length > 0) {
                        const fileid = this.state.activeFileIndex.fileid;
                        const fileDetail = data.findIndex(x => x.id === fileid);
                        if (fileid > -1 && fileDetail > -1) {
                            this.openFileViewModal(fileDetail, data[fileDetail]);
                        } else {
                            this.openFileViewModal(0, data[0]);
                        }
                    } else {
                        this.setState({
                            pageLoading: false,
                            imageLoading:false,
                            loading: false,
                            activeFileIndex: { index: -1, fileid: -1 },
                        });
                    }
                });
            }
        ).catch(error => {
            if (error?.status === 401) {
                store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
                logout(this.props.history, false);
                removeSideBar();
            } else { }
        });
    }

    getExemptionList = () => {
        const data = {
            "sort": [{ "field": "modifieddate", "direction": "desc" }],
            "field": ["id", "locationid", "validityexpirydate", "notes", "locationtitle","istaxexempt","modifieddate"],
            "filter": [{ "field": "buyerid", "value": this.props.user.id, "op": "=", "join": "AND" }],
            "page": { "size": 500 }
        }
        MyAccountService.getExemptionList(data).then(
            response => {
                const temp = response.data.data;
                this.setState({
                    exemptioList: temp
                })
            }
        ).catch(error => {
            if (error?.status === 401) {
                store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
                logout(this.props.history, false);
            } else { }
        });
    }

    onUploadFile = async (event) => {
        if (this.props.user.profilecompleted === 1) {
            this.certificateFile = event.target.files[0];
            // const filesize = parseInt(parseFloat(this.certificateFile.size / 1048576).toFixed(0));
            // if (filesize <= 5) {
            if (this.certificateFile.type === "application/pdf") {
                this.setState({
                    certificateFile: {
                        ...this.state.certificateFile,
                        fileSrc: URL.createObjectURL(event.target.files[0]),
                        modal: false,
                        viewFileDetails: this.certificateFile,
                        date: moment().format('MM-DD-YYYY')
                    },
                    fileError: ""
                });
            } else if (this.certificateFile.type.includes('image/')) {
                let filesize = this.formatBytes(this.certificateFile['size']);
                const mimetype = await FileType.fromBlob(this.certificateFile);
                if (mimetype?.ext === 'heic') {
                    
                    if (mimetype?.mime === 'image/heic') {
                        this.setState({
                            fileError: "This file format is not supported currently."
                        }, () => {
                            setTimeout(() => {
                                this.setState({
                                    fileError: null,
                                });
                            }, 8000);
                        });
                        return;
                    } else {
                        this.setState({ imageLoading: true });
                        const blob =  await heic2any({
                            blob: event.target.files[0],
                            toType: 'image/jpeg'
                        });

                        this.certificateFile = blobToFile(blob, event.target.files[0].name);

                        this.setState({ imageLoading: false });
                    }
                } 

                if (filesize['size'] > 4) {
                    this.setState({
                        "isCompressing": true,
                        "percentage": 50
                    });
                    let IMAGE_OUTPUT_QUALITY = 5; // in MB
                    if (filesize['size'] > 5 && filesize['size'] < 20){
                        IMAGE_OUTPUT_QUALITY = 1;
                    } else if(filesize['size'] > 20 && filesize['size'] < 50){
                        IMAGE_OUTPUT_QUALITY = 2;
                    } else if(filesize['size'] > 50 && filesize['size'] < 100){
                        IMAGE_OUTPUT_QUALITY = 3;
                    } else {
                        IMAGE_OUTPUT_QUALITY = 4;
                    }

                    const convertOptions = {
                        maxSizeMB: IMAGE_OUTPUT_QUALITY,
                        maxWidthOrHeight: 1920,
                        useWebWorker: true
                    }

                    const compressedFile = await imageCompression(this.certificateFile, convertOptions);
                    this.certificateFile = blobToFile(compressedFile, this.certificateFile.name);

                    this.setState({
                        "isCompressing": false,
                        "percentage": 0
                    });
                }

                this.setState({
                    certificateFile: {
                        ...this.state.certificateFile,
                        fileSrc: URL.createObjectURL(event.target.files[0]),
                        modal: false,
                        viewFileDetails: this.certificateFile,
                        date: moment().format('MM-DD-YYYY')
                        // tempFile: URL.createObjectURL(output.dest),
                        // modal: true,
                        // viewFileDetails: null
                    },
                    fileError: ""
                });
            }
             
        }
        event.target.value = '';
    };

    formatBytes(bytes) {
        var kb = 1024;
        var ndx = Math.floor(Math.log(bytes) / Math.log(kb));
        var fileSizeTypes = ["bytes", "kb", "mb", "gb", "tb", "pb", "eb", "zb", "yb"];

        return {
            size: +(bytes / kb / kb).toFixed(2),
            type: fileSizeTypes[ndx]
        };
    }

    onCancelFile = () => {
        this.setState({
            certificateFile: {
                ...this.state.certificateFile,
                modal: false,
                tempFile: null,
                viewFileDetails: null
            }
        });
    };

    onSaveImage = (output) => {
        this.setState({
            certificateFile: {
                ...this.state.certificateFile,
                fileSrc: URL.createObjectURL(output.dest),
                modal: false,
                viewFileDetails: this.certificateFile
            }
        });
    }

    // generate file url, this url will be file's server url
    createFileUrl = (fileDetail, key) => {
        // this is the standard url format used in backend(finally convert to base64)
        return btoa('BIG' + fileDetail['filename'] + '$' + key + '$' + fileDetail['size'] + '$' + fileDetail['partCount']);
    };

    uploadByFragment = (file, partKey, chunks) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.onerror = reject;
            fileReader.onload = () => {
                const base64 = fileReader?.result?.replace('data:', '').replace(/^.+,/, '');
                chunks.push(base64);
                const fragment = {
                    data: {
                        partkey: partKey,
                        partid: chunks?.length,
                        content: base64
                    }
                };
                resolve(axios.post(getBuyersUrl(fileUploadFragment), fragment, getBuyerHeaders()));
            }
            fileReader.readAsDataURL(file);
        });
    }

    uploadFile = () => {
        return new Promise(async (resolve, reject) => {
            const file = this.state?.certificateFile?.viewFileDetails;
            const fileName = file?.name;
            let fileUrl = '';

            const chunkSize = Math.ceil(1024 * 1024 * 3); // equals to 3mb
            const fileSize = file.size;
            const totalChunks = Math.ceil(fileSize / chunkSize, chunkSize);
            let chunkCount = 0;
            let offset;
            const chunks = [];
            const body = {
                data: {
                    filename: fileName,
                    size: fileSize,
                    partCount: totalChunks
                }
            };
            await axios.post(getBuyersUrl(fileUpload), body, getBuyerHeaders())
                .then(async (response) => {
                    const partKey = response?.data?.['partkey'];
                    fileUrl = this.createFileUrl(body.data, partKey);
                    while (chunkCount < totalChunks) {
                        offset = chunkCount * chunkSize;
                        try {
                            await this.uploadByFragment(file.slice(offset, offset + chunkSize), partKey, chunks);
                        } catch (error) {
                            reject(error);
                            break;
                        }
                        chunkCount++;
                    }
                    resolve({ fileUrl, fileName });
                }).catch(error =>
                    reject(error)
                );
        });
    }

    submitFile = () => {
        this.setState({
            loading: true
        }, async () => {
            try {
   
                    const { fileUrl, fileName } = await this.uploadFile();
                    const userId = this.props?.user?.id;
                    const data = {
                        "data": {
                            "buyerid": userId,
                            "name": fileName,
                            "file": fileUrl
                        }
                    };
                    await MyAccountService.TaxFileUplaod(data);
                    this.setState({
                        certificateFile: {
                            ...this.state.certificateFile,
                            fileSrc: null,
                            modal: false,
                            tempFile: null,
                            viewFileDetails: null
                        }
                    }, () => {
                        this.getTaxFileList();
                    });
              

                
            } catch (error) {
                let message = error.message;
                if (error.status && error.status === 412) {
                    message = "Please Upload file less than 3 mb";
                }
                this.setState({
                    loading: false,
                    fileError: message
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            fileError: null,
                        });
                    }, 8000);
                });
            }
        });
    }

    removeFile = (event, index, file) => {
        event.stopPropagation();
        this.setState({
            deleteInprogress: index
        }, () => {
            const data = {
                "data": {
                    "id": file.id
                }
            }
            MyAccountService.deleteTaxExemptionFile(data).then(
                response => {
                    this.getTaxFileList();
                }
            ).catch(error => {
                this.getTaxFileList();
            });
        });
    }

    openFileViewModal = (index, file) => {
        this.setState({
            activeFileIndex: { index: index, fileid: file.id },
            pageLoading: false,
            loading: false
        });
    }



    getFileDetails = (file) => {
        if (file) {
            const url = file.name;
            const file_details = url.split('/').pop();
            const file_type = file_details.split('.').pop();
            const final = { file_name: file_details, file_type };
            return final;
        } else {
            return null;
        }
    }

    profileComplete = () => {
        this.props.history.push(`/my-account/my-info/personal-info`);
    }

    navBarChange = (flag) => {
        this.setState({
            activeNavBar: flag
        })
    }

    viewExemption = (exemption) => {
        this.setState({
            viewExemptionDetailsModal: { open: true, exemption: exemption }
        })
    }

    closeExemptionViewModal = () => {
        this.setState({
            viewExemptionDetailsModal: { open: false, exemption: null }
        });
    }

    windowResizeHandle = () => {
        ToggleSideBar();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.windowResizeHandle);
        store.dispatch({ type: 'SET_SIDEBAR', payload: false });

        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    render() {
        return (
          
            <div className="tax-exemptions-main top-border">
                {this.state.imageLoading == true ?
                    <div className="imgloader d-flex align-items-center justify-content-center z-index-3">
                        <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                    </div> : null}
                {
                    this.state.pageLoading == true ?
                    <div className="loader d-flex align-items-center justify-content-center z-index-3">
                        <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                    </div> :
                        <div className="main-content">
                            <div className="form-container">
                                <div className="header">
                                    Upload valid tax exemptions certificate
                                </div>
                                <div className="d-flex" style={{ width: "100%" }}>
                                    <Form style={{ width: "30%" }}>
                                        <Form.File id="formcheck-api-custom" custom>
                                            <Form.File.Input size="lg" onChange={this.onUploadFile} accept={CERTIFICATE_TYPES} disabled={this.props.user.profilecompleted === 0} />
                                            <Form.File.Label data-browse="Browse" className="label-height">
                                                {this.state.certificateFile.viewFileDetails ? this.state.certificateFile.viewFileDetails.name : "Supports (.jpeg, .jpg, .heic, .png, .pdf)"}
                                            </Form.File.Label>
                                            <Form.Text>
                                                {
                                                    this.props.user.profilecompleted === 0 && isAuthorized() ?
                                                        <div className="text-danger">Profile not completed. <span className="external-link" onClick={this.profileComplete}>Complete profile</span></div> : null
                                                }

                                            </Form.Text>
                                        </Form.File>
                                    </Form>
                                    <div className="buttons">
                                        <Button variant="secondary" onClick={this.submitFile} disabled={!this.state.certificateFile.viewFileDetails || this.state.loading || this.props.user.profilecompleted === 0}>
                                            Add {' '} {this.state.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}
                                        </Button>
                                    </div>
                                </div>
                                {
                                    this.state.fileError ? <div className="text-danger mt-6">{this.state.fileError}</div> : null
                                }
                            </div>
                            <div className="nav-bar d-flex align-items-center">
                                <div className={`${this.state.activeNavBar === 'files' ? 'active' : ''} clickable`} onClick={() => this.navBarChange('files')}>Files</div>
                                <div className={`${this.state.activeNavBar === 'exemptionlist' ? 'active' : ''} clickable`} onClick={() => this.navBarChange('exemptionlist')}>Exemption List</div>
                                <div className={`d-xs-block d-none flex-row align-items-center scroll-indicator`}>
                                    <span className="mx-1">Scroll</span>
                                    <i className="fas fa-angle-right first-angle"></i>
                                    <i className="fas fa-angle-right second-angle"></i>
                                    <i className="fas fa-angle-right third-angle"></i>
                                </div>
                            </div>
                            {
                                this.state.activeNavBar === 'files' ?
                                    <div className="file-list-container d-flex align-items-start">
                                        <div className="left-side">
                                            {
                                                this.state.finalCertificateFile.length > 0 ?
                                                    <div className="container-section">
                                                        {
                                                            this.state.finalCertificateFile.map((files, index) =>
                                                                <div className={`file-list ${this.state.activeFileIndex.index === index ? 'active' : ''}`} key={`file_${index}`} onClick={() => this.openFileViewModal(index, files)}>
                                                                    <div className="file-detail d-flex align-items-center justify-content-between">
                                                                        <div className="mx-w-90">
                                                                            <div className="file-name">
                                                                                {files.name}
                                                                            </div>
                                                                        </div>
                                                                        {
                                                                            files.verified === 0 ?
                                                                                <div className="buttons d-flex align-items-center">
                                                                                    {
                                                                                        this.state.deleteInprogress === index ?
                                                                                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"></Spinner> :
                                                                                            <i className="fas fa-trash-alt" onClick={(event) => this.removeFile(event, index, files)}></i>
                                                                                    }
                                                                                </div> : null
                                                                        }
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                    </div> : null
                                            }

                                        </div>
                                        <div className="right-side">
                                            {
                                                this.state.activeFileIndex.index > -1 ?
                                                    <div>
                                                        {
                                                            this.getFileDetails(this.state.finalCertificateFile[this.state.activeFileIndex.index])?.file_type === 'pdf' ?
                                                                <object className="pdf-file-viewer" data={this.state.finalCertificateFile[this.state.activeFileIndex.index]?.url} type="application/pdf">
                                                                    <embed src={`${this.state.finalCertificateFile[this.state.activeFileIndex.index]?.url}##view=FitH&scrollbar=1&toolbar=1`} type="application/pdf" />
                                                                </object> :
                                                                <div className="d-flex align-items-center justify-content-center">
                                                                    <img src={this.state.finalCertificateFile[this.state.activeFileIndex.index]?.url} alt="taxexempt-image" className="image-file-viewer"></img>
                                                                </div>
                                                        }
                                                    </div> : null
                                            }
                                        </div>

                                    </div> : <div>
                                        <div className="list-container">
                                            <Table>
                                                <thead>
                                                    <tr>
                                                        <th>Locations</th>
                                                        <th>Expiration Date</th>
                                                        <th>Notes</th>
                                                        <th>Tax Exempted</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.exemptioList.map((exemption, index) =>
                                                            <tr key={`exemption_${index}`}>
                                                                <td>{exemption.locationtitle}</td>
                                                                <td>{exemption?.validityexpirydate ? moment(exemption.validityexpirydate).format('MMM-DD-YYYY') : '---'}</td>
                                                                {/* <td className="d-flex align-items-center justify-content-center table-action">
                                                                    <img src={`${process.env.PUBLIC_URL}/static/icons/table/view.svg`} alt="close-icon" className="clickable" onClick={() => this.viewExemption(exemption)}></img>
                                                                </td> */}
                                                                <td>
                                                                    <div className="textWrap">
                                                                        {exemption.notes}
                                                                    </div>
                                                                </td>
                                                                <td>{  exemption.istaxexempt === 0 ? `Rejected` :  moment(exemption.validityexpirydate).isAfter(`${moment(new Date()).format('YYYY-MM-DD')}`) ? `Approved` : `Expired`}</td>
                                                            </tr>

                                                        )
                                                    }
                                                    {
                                                        this.state.exemptioList.length === 0 ? <tr>
                                                            <td colSpan={4}>
                                                                <div className="text-center">No data available</div>
                                                            </td>
                                                        </tr> : null
                                                    }
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                            }
                            {
                                this.state.activeNavBar === 'files' && this.state.finalCertificateFile.length === 0 ?
                                    <div className="text-center">
                                        <div>No data available</div>
                                    </div> : null
                            }

                        </div>
                }

                {/* dialog box for upprofileFormLoading profile image */}
                <Modal show={this.state.certificateFile.modal} size="lg" animation={false} backdrop="static" onHide={this.onCancelFile}>
                    <Modal.Header closeButton></Modal.Header>
                    <Modal.Body className="d-flex flex-column align-items-center justify-content-center">
                        <div style={{ width: '100%', height: '400px', maxHeight: '80vw' }}>
                            <DokaImageEditor {...getEditorDefaults({ width: 130, height: 130 })}
                                {...this.customEditorDefaults} src={this.state.certificateFile.tempFile}
                                onProcess={this.onSaveImage} />
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal centered show={this.state.isCompressing} size="md" animation={false} >
                    <Modal.Header>
                        {<h6>Uploading media files ...</h6>} 
                    </Modal.Header>
                    <Modal.Body className="d-flex flex-column align-items-center justify-content-center">
                        <div className="progressBar" id="progressBar" style={{ width: '100%' }}>
                            <ProgressBar id="progressBarimg"  variant="success" animated now={this.state.percentage} min={0} max={100} label={this.state.percentage.toFixed() +' %'}  />
                        </div>
                    </Modal.Body>
                </Modal>

                {/* dialog box for upprofileFormLoading profile image */}
                <Modal show={this.state.viewExemptionDetailsModal.open} animation={false} backdrop="static" centered>
                    <Modal.Header>
                        <div className="d-flex align-items-center justify-content-between w-100">
                            <h5 className="text-secondary"> <b>Tax Exemption</b></h5>
                            <div type="button" className=" close text-right" onClick={this.closeExemptionViewModal}><span aria-hidden="true">×</span><span className="sr-only">Close</span></div>
                        </div>
                    </Modal.Header>
                    <Modal.Body className="d-flex flex-column align-items-center justify-content-center exemption-modal">
                        <Form className="mx-5 mt-2">
                            <div className="calendar-box">
                                <div className="input-group">
                                    <input className="form-control form-control-lg py-2" placeholder="Search for any item"
                                        value={this.state.viewExemptionDetailsModal.exemption?.locationid}
                                        disabled></input>
                                    <span className="input-group-append align-items-center">
                                        <i className="fas fa-chevron-down"></i>
                                    </span>
                                </div>
                            </div>
                            <div className="calendar-box">
                                <div className="input-group">
                                    <input className="form-control form-control-lg py-2" placeholder="Search for any item"
                                        value={this.state.viewExemptionDetailsModal.exemption?.validityexpirydate ? moment(this.state.viewExemptionDetailsModal.exemption?.validityexpirydate).format('MMM-DD-YYYY') : ''}
                                        disabled></input>
                                    <span className="input-group-append align-items-center">
                                        <i className="fas fa-calendar"></i>
                                    </span>
                                </div>
                            </div>
                            <div className="calendar-box">
                                <div className="input-group">
                                    <textarea className="form-control form-control-lg py-2" placeholder="Add notes"
                                        value={this.state.viewExemptionDetailsModal.exemption?.notes} disabled></textarea>
                                </div>
                            </div>
                        </Form>
                    </Modal.Body>
                </Modal>

            </div>
        );
    }
}

export default connect(state => state)(TaxExemptions);
